// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
})();

// custom QuantityInput

class CustomQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.InputChangeMain();
  }

  // InputChangeMain(){
  //   const inputValue = this.input.value;
  //   const parent = this.closest('[custom_qty_selector]');    
  //   const qtySelector = parent.querySelector('quantity-input input');
  //   qtySelector.value = inputValue * 100;
  //  const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
  //    if(cartItems) cartItems.updateQuantity(qtySelector.dataset.index,inputValue * 100 , qtySelector);
  
  //   // console.log("parent",qtySelector);
  // }

  InputChangeMain() {
    const inputValue = parseFloat(this.input.value) || 0;
    const parent = this.closest('[custom_qty_selector]');
    if (!parent) return;
    const qtySelector = parent.querySelector('quantity-input input');
    if (!qtySelector) return;
    const cartQty = Math.round(inputValue * 10);
    qtySelector.value = cartQty;
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    // console.log('cartItems', cartItems);

    if (cartItems) {
      const line = qtySelector.dataset.index;
      const quantity = cartQty;
      const varid = qtySelector.dataset.quantityVariantId;
      // console.log("varid",varid)
      // const prop = { 'Länge': (quantity*1.0)/10 };
      // First update quantity
      cartItems.updateQuantity(line, quantity, qtySelector,document.activeElement.getAttribute('name'),varid,true);

      // updateLineItemProperties(line, prop, true);
              
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    const button = event.currentTarget; // safe, button itself
    const step = parseFloat(this.input.step) || 0.1;
    const min = parseFloat(this.input.min) || 0.5;
    const max = parseFloat(this.input.max) || Infinity;
    let value = parseFloat(this.input.value) || min;

    // Align value to nearest step from min
    value = +(Math.round((value - min) / step) * step + min).toFixed(2);

    if (button.name === 'plus') {
      value = Math.min(value + step, max);
    } else if (button.name === 'minus') {
      value = Math.max(value - step, min);
    }

    // Update input
    this.input.value = value.toFixed(1);

    console.log("this",this)

    const qty_input = this.querySelector('[qty_input]');
    if(qty_input) qty_input.value = this.input.value;

    // Trigger Shopify-recognized events
    const inputEvent = new Event('input', { bubbles: true, cancelable: true });
    const changeEvent = new Event('change', { bubbles: true, cancelable: true });
    this.input.dispatchEvent(inputEvent);
    this.input.dispatchEvent(changeEvent);

    this.validateQtyRules();
    this.InputChangeMain();

    // Update price block
    const main_p = this.closest('product-info');
    if(main_p){
      const priceBlocks = main_p.querySelectorAll('.pdp-price-block .pdp_price.price-item[data-price-check]');
      const comparepriceBlocks = main_p.querySelectorAll('.pdp-price-block .pdp_price.price-compare-item[data-compare-price]');
      const parent_q = this.closest('[custom_qty_selector]');
      const qtySelector = parent_q.querySelector('quantity-input input');

      if (priceBlocks.length > 0) {
        priceBlocks.forEach(priceBlock => {
          const priceCheckValue = parseFloat(priceBlock.dataset.priceCheck);
          const inputValue = parseFloat(qtySelector.value);
          // console.log("priceCheckValue",priceCheckValue)
          // console.log("inputValue",inputValue)

          if (!isNaN(priceCheckValue) && !isNaN(inputValue)) {
            const total = priceCheckValue * inputValue;
            // console.log("total",total)

            let pricesplit = priceBlock.querySelector('[main_price]');
            let qtysplit = priceBlock.querySelector('[unit_price]');
            // console.log("qtysplit",qtysplit)
            if (qtysplit) {
              qtysplit.innerHTML = parseFloat(this.input.value);
            }
            if(pricesplit){
            const price_val = theme.Currency.formatMoney(total * 100, theme.moneyFormat);
              pricesplit.innerHTML = price_val.replace('.',',');
              // console.log("pricesplit", price_val);
            }
          }
        });
      }
      if (comparepriceBlocks.length > 0) {
        comparepriceBlocks.forEach(comparepriceBlocks => {
          const cpriceCheckValue = parseFloat(comparepriceBlocks.getAttribute('data-compare-price'));
          // console.log(cpriceCheckValue,"cpriceCheckValue")
          const CinputValue = parseFloat(qtySelector.value);
          // console.log("CinputValue",CinputValue)

          if (!isNaN(cpriceCheckValue) && !isNaN(CinputValue)) {
            const ctotal = cpriceCheckValue * CinputValue;
            // console.log("ctotal",ctotal)

            let cpricesplit = comparepriceBlocks.querySelector('[main_compare_price]');
            let cqtysplit = comparepriceBlocks.querySelector('[unit_price]');
            // console.log("cqtysplit",cqtysplit)

            if (cqtysplit) {
              cqtysplit.innerHTML = parseFloat(this.input.value);
            }
            if (cpricesplit) {
              const cprice_val = theme.Currency.formatMoney(ctotal * 100, theme.moneyFormat);
              cpricesplit.innerHTML = cprice_val.replace('.',',');
            }
          }
        });
      }
    }
  }

  validateQtyRules() {
    const value = parseFloat(this.input.value) || parseFloat(this.input.min) || 0.25;

    const buttonMinus = this.querySelector(".quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".quantity__button[name='plus']");

    // console.log("value",this.input,this.input.value);

    if (buttonMinus && this.input.min)
      buttonMinus.classList.toggle('disabled', value <= parseFloat(this.input.min));
    if (buttonPlus && this.input.max)
      buttonPlus.classList.toggle('disabled', value >= parseFloat(this.input.max));
  }


}

customElements.define('custom-quantity-input', CustomQuantityInput);


function updateLineItemProperties(index, newProperties,open_drawer) {
  // console.log("index",index)
  // console.log("newProperties",newProperties)
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // console.log("cart",cart)
      // console.log("index",index - 1)      
      const item = cart.items[index - 1];

      if (!item) {
        console.error('Invalid line index');
        return;
      }

      // console.log("item",item)

      const mergedProperties = {
        ...(item.properties || {}),
        ...newProperties
      };

      // console.log("mergedProperties",mergedProperties)

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: index,
          quantity: item.quantity,
          properties: mergedProperties
        })
      });
      // console.log("body",body)
    })
    .then(res => res.json())
    .then(data => {
      // console.log('Cart updated', data);
      const this_cartPage = document.querySelector('cart-items');
      if (!this_cartPage){
        if (open_drawer) {
          const this_cartDrawer = document.querySelector('cart-drawer');
          if (this_cartDrawer) {
            this_cartDrawer.refresh(true);  
          }        
        }
      }else{
        this_cartPage.onCartUpdate();
      }
      return data;
    });
}


// RED MORE START

class ReadMoreMain extends HTMLElement {
  constructor() {
    super();

    this.facetLink = this.querySelector('[data-redmore-btn]');
    this.contentMainContent = this.querySelector('[data-main-content]');
    this.mainContentWrapper = this.querySelector('[data-main-conteaner-wapper]');

    if (!this.facetLink || !this.contentMainContent) return;

    this.initialize();
    this.facetLink.addEventListener('click', this.toggleContent.bind(this));
  }

  initialize() {
    const totalHeight = this.mainContentWrapper.offsetHeight;
    const currentHeight = this.contentMainContent.offsetHeight;
    this.collapsedHeight = currentHeight;

    // Set the initial state with collapsed content
    this.contentMainContent.style.height = this.collapsedHeight;    
    this.facetLink.innerHTML = this.facetLink.getAttribute('data-red-more-text');

    // Hide the button if the content doesn't need collapsing

    console.log(this.collapsedHeight);
    console.log(this.contentMainContent.scrollHeight,this.contentMainContent)
    if (this.contentMainContent.scrollHeight <= currentHeight) {
      this.facetLink.classList.add('hidden');
    }
  }

  toggleContent(event) {
    event.preventDefault();
    const isCollapsed = this.contentMainContent.offsetHeight === this.collapsedHeight;

    console.log(this.contentMainContent.offsetHeight,this.collapsedHeight );
    console.log(isCollapsed)

    if (isCollapsed) {
      this.contentMainContent.style.height = 'auto';
      this.contentMainContent.classList.add('active');
      this.facetLink.innerHTML = this.facetLink.getAttribute('data-red-less-text');
    } else {
      this.contentMainContent.style.height = `${this.collapsedHeight}px`;
      this.contentMainContent.classList.remove('active');
      this.facetLink.innerHTML = this.facetLink.getAttribute('data-red-more-text');
    }
  }
}

customElements.define('read-more-main', ReadMoreMain);

// RED MORE END



const popup = document.querySelector('#popup1');
const show_time = popup.getAttribute("data-popup-time");
console.log("show_time",show_time);
const cookieName = "popup--closed"; // Cookie key
const cookieDuration = 7; // in days

// Function to set cookie
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
 

// Show popup if no cookie
if (popup && !getCookie(cookieName)) {
  setTimeout(() => {
    popup.classList.add("open");
    document.body.classList.add("popup_open");
  }, show_time);
  // Close popup and set cookie when clicking close button
  popup.querySelectorAll('[data-popup-close]').forEach(closeBtn => {
    closeBtn.addEventListener('click', function () {
      popup.classList.remove("open");
      document.body.classList.remove("popup_open");

      // Set cookie to prevent future popup
      setCookie(cookieName, "true", cookieDuration);
    });
  });
}



// class CustomHeaderdetails extends HTMLElement {
//   constructor() {
//     super();

//     this.mainDetailsToggle = this.querySelector('details');

//     this.addEventListener('keyup', this.onKeyUp.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.querySelectorAll('summary').forEach((summary) =>
//       summary.addEventListener('click', this.onSummaryClick.bind(this))
//     );
//     this.querySelectorAll(
//       'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.is_grandchild_closebtn)'
//     ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
//     // this.querySelectorAll(
//     //   'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
//     // ).forEach((button) => {
//     //   this.onCloseBtnClick(button);
//     // });
//   }

//   onKeyUp(event) {
//     if (event.code.toUpperCase() !== 'ESCAPE') return;

//     const openDetailsElement = event.target.closest('details[open]');
//     if (!openDetailsElement) return;

//     openDetailsElement === this.mainDetailsToggle
//       ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
//       : this.closeSubmenu(openDetailsElement);
//   }

//   onSummaryClick(event) {
//     const summaryElement = event.currentTarget;
//     const detailsElement = summaryElement.parentNode;
//     // console.log("detailsElement",detailsElement)
//     const parentMenuElement = detailsElement.closest('.has-submenu-custom');
//     const isOpen = detailsElement.hasAttribute('open');
//     const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');3

//     // console.log("parentMenuElement",parentMenuElement)

//     function addTrapFocus() {
//       trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
//       summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
//     }

//     // console.log("this.mainDetailsToggle",this.mainDetailsToggle)
//     // console.log("detailsElement",detailsElement)

//     if (detailsElement === this.mainDetailsToggle) {
//       if (isOpen) event.preventDefault();
//       isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);


//       setTimeout(() => {
//         detailsElement.classList.add('menu-opening');
//         summaryElement.setAttribute('aria-expanded', true);
//         parentMenuElement && parentMenuElement.classList.add('submenu-open-custom');
//         !reducedMotion || reducedMotion.matches
//           ? addTrapFocus()
//           : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
//       }, 100);

//       if (window.matchMedia('(max-width: 990px)')) {
//         document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
//       }
//     } else {
//       setTimeout(() => {
//         detailsElement.classList.add('menu-opening');
//         summaryElement.setAttribute('aria-expanded', true);
//         parentMenuElement && parentMenuElement.classList.add('submenu-open-custom');
//         !reducedMotion || reducedMotion.matches
//           ? addTrapFocus()
//           : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
//       }, 100);
//     }
//   }

//   openMenuDrawer(summaryElement) {
//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add('menu-opening');
//     });
//     summaryElement.setAttribute('aria-expanded', true);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }

//   closeMenuDrawer(event, elementToFocus = false) {
//     if (event === undefined) return;

//     this.mainDetailsToggle.classList.remove('menu-opening');
//     this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
//       details.removeAttribute('open');
//       details.classList.remove('menu-opening');
//     });
//     console.log("this.mainDetailsToggle",this.mainDetailsToggle)
//     this.mainDetailsToggle.querySelectorAll('.submenu-open-custom').forEach((submenu) => {
//       console.log("submenu",submenu)
//       submenu.classList.remove('submenu-open-custom');
//     });
//     document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
//     removeTrapFocus(elementToFocus);
//     this.closeAnimation(this.mainDetailsToggle);

//     if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
//         this.closeMenuDrawer();
//     });
//   }

//   onCloseBtnClick(button){
//     // console.log("button",button)

//   }

//   onCloseButtonClick(event) {
//     const detailsElement = event.currentTarget.closest('details');
//     console.log("detailsElement",detailsElement,event.target);

//     setTimeout(() => {
//       this.closeSubmenu(detailsElement);
//     });
//   }

//   closeSubmenu(detailsElement) {
//     // console.log("detailsElement",detailsElement.closest('.has-submenu-custom.submenu-open-custom'))
//     const parentMenuElement = detailsElement.closest('.submenu-open-custom');
//     console.log("parentMenuElement",parentMenuElement);
//     parentMenuElement && parentMenuElement.classList.remove('submenu-open-custom');
//     detailsElement.classList.remove('menu-opening');
//     detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
//     removeTrapFocus(detailsElement.querySelector('summary'));
//     this.closeAnimation(detailsElement);
//   }

//   closeAnimation(detailsElement) {
//     let animationStart;

//     const handleAnimation = (time) => {
//       if (animationStart === undefined) {
//         animationStart = time;
//       }

//       const elapsedTime = time - animationStart;

//       if (elapsedTime < 400) {
//         window.requestAnimationFrame(handleAnimation);
//       } else {
//         detailsElement.removeAttribute('open');
//         if (detailsElement.closest('details[open]')) {
//           trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
//         }
//       }
//     };

//     window.requestAnimationFrame(handleAnimation);
//   }
// }

// customElements.define('custom-header-details', CustomHeaderdetails);


class CustomHeaderdetailsSub extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.is_child_closebtn)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    // this.querySelectorAll(
    //   'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    // ).forEach((button) => {
    //   this.onCloseBtnClick(button);
    // });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    // console.log("detailsElement",detailsElement)
    const parentMenuElement = detailsElement.closest('.has-submenu-custom');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');3

    // console.log("parentMenuElement",parentMenuElement)

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    // console.log("this.mainDetailsToggle",this.mainDetailsToggle)
    // console.log("detailsElement",detailsElement)

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);


      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open-custom');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open-custom');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    console.log("this.mainDetailsToggle",this.mainDetailsToggle)
    this.mainDetailsToggle.querySelectorAll('.submenu-open-custom').forEach((submenu) => {
      console.log("submenu",submenu)
      submenu.classList.remove('submenu-open-custom');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseBtnClick(button){
    // console.log("button",button)

  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    console.log("detailsElement",detailsElement,event.target);

    setTimeout(() => {
      this.closeSubmenu(detailsElement);
    });
  }

  closeSubmenu(detailsElement) {
    // console.log("detailsElement",detailsElement.closest('.has-submenu-custom.submenu-open-custom'))
    const parentMenuElement = detailsElement.closest('.submenu-open-custom');
    console.log("parentMenuElement",parentMenuElement);
    parentMenuElement && parentMenuElement.classList.remove('submenu-open-custom');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('custom-header-details-sub', CustomHeaderdetailsSub);


// tab click to scroll
function smoothScroll(targetElement) {
  const headerHeight = (document.querySelector('sticky-header')?.offsetHeight + 10) || 150;    

  if (targetElement) {
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth"
    });
  }
}

if (window.location.hash === "#fromtab") {
  const tabSection = document.querySelector(".tab-section");
  if (tabSection) {
    setTimeout(() => {
      smoothScroll(tabSection);
      window.history.replaceState({}, '', `${window.location.href.split('#')[0]}`);
    }, 300);
  }
}


  




